export const information = {
    location: '2274 Wednesday Street, Tallahassee, FL 32308',
    locationUrl:
        'https://www.google.com/maps/place/First+Care+Dental/@30.4802611,-84.2388062,15z/data=!4m6!3m5!1s0x88ec5f3ab584375d:0x30748933dfbe810b!8m2!3d30.4802611!4d-84.2388062!16s%2Fg%2F1tj6vnjk',
    phone: '(850) 309-0970',
    email: '',
};
